// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"405":"1e1bca11","3777":"70b4f6cc"}[chunkId] + ".chunk.css";
};